import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { UploadInput, UploadOutput, UploaderOptions } from 'ngx-uploader';
import { STORAGE_LOCATIONS } from '../../../../enums';
import { finalize } from 'rxjs/operators';
import { LoopBackConfig, LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { TermsAndConditionApi } from '../../../../../assets/js/lb-sdk/services/custom/TermsAndCondition';
import { formatEvent } from '@app/helpers/upload-input-formatter'    

interface TermsAndConditionForm {
  id?: string,
  versionNumber?: string,
  pdfFile?: any
}

@Component({
  selector: 'app-terms-and-conditions-form',
  templateUrl: './terms-and-conditions-form.component.html',
  styleUrls: ['./terms-and-conditions-form.component.css']
})
export class TermsAndConditionsFormComponent implements OnInit {
  data: TermsAndConditionForm;
  loading: boolean = false;
  error: string;
  file;
  uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
  options: UploaderOptions = {
    concurrency: 1,
    allowedContentTypes: ['application/pdf']
  };

  constructor(
    public modal: BsModalRef,
    private termsAndConditionsApi: TermsAndConditionApi,
    private loopBackAuth: LoopBackAuth
  ) { }

  ngOnInit() {
    if (this.data) {
      let {
        id,
        versionNumber
      } = this.data;
      this.data = { id, versionNumber };
    } else {
      this.data = {};
    }
  }

  onUploadOutput(output: UploadOutput) {
    switch (output.type) {
      case 'addedToQueue':
        if (typeof output.file !== 'undefined') {
          this.error = undefined;
          this.file = output.file;
        }
        break;
      case 'start':
        this.loading = true;
        break;
      case 'rejected':
        this.data.pdfFile = undefined;
        this.file = undefined;
        this.error = 'File Rejected';
        break;
      case 'done':
        setTimeout(() => {
          this.loading = false;
          if (output.file && output.file.responseStatus === 200) {
            this.modal.content.result = 'success';
            this.modal.hide();
          } else {
            if (output && output.file && output.file.response && output.file.response.error && output.file.response.error.message && output.file.response.error.message.indexOf('uniqueVersionNumber') >= 0) {
              this.error = 'Version number already used';
            } else {
              this.error = 'File Upload failed';
            }
            this.file = undefined;
            this.data.pdfFile = undefined;
          }
        }, 1000);
        break
      default:
        break;
    }
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(form) {
    if (form.valid) {
      if (this.data.pdfFile) {
        const path = LoopBackConfig.getPath() + '/api/AmazonS3/' + STORAGE_LOCATIONS.TERMS_AND_CONDITIONS + '/upload';
        if (path && path !== '') {
          const event = formatEvent('uploadAll',path,
            this.loopBackAuth.getToken() && this.loopBackAuth.getToken().id || '', 
            { versionNumber: this.data.versionNumber }
          )
          this.uploadInput.emit(event);
        }
      } else {
        this.termsAndConditionsApi
          .patchAttributes(this.data.id, {
            versionNumber: this.data.versionNumber
          })
          .pipe(finalize(() => {
            // DO SOMETHING AFTER UPDATE
          }))
          .subscribe(() => {
            this.modal.content.result = 'success';
            this.modal.hide();
          }, error => {
            this.error = (error && error.message && error.message.indexOf('uniqueVersionNumber') >= 0) ? 'Version number already used' : 'Terms and Condition update failed';
          });
      }
    }
  }
}
